import { makeStyles } from '@material-ui/core'
import { ERROR_COLORS, GRAY_COLORS, SUCCESS_COLORS } from 'asterX-UI'

export const useDocumentStyles = makeStyles(theme => ({
  title: {
    color: GRAY_COLORS[900],
    fontSize: 24,
    fontWeight: 600,
    paddingLeft: 8
  },
  card: {
    border: `1px solid ${GRAY_COLORS[200]}`,
    borderRadius: 12,
    padding: '12px 20px',
    transition: 'border 0.2s, box-shadow 0.2s, transform 0.2s'
  },
  cardHovered: {
    boxShadow: `0 4px 24px 0 rgba(30, 136, 229, 0.15), 0 0 0 2px #1976d2` ,
    borderColor: '#1976d2',
    background: '#f5faff'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    padding: 0,
    '&:last-child': {
      paddingBottom: 0
    }
  },
  cardSubtitle: {
    color: GRAY_COLORS[600],
    fontSize: 14
  },
  cardTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: GRAY_COLORS[900]
  },
  workList: {
    display: 'flex',
    gap: 20,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  description: {
    fontSize: 14,
    fontWeight: 400,
    color: GRAY_COLORS[500]
  },
  answer: {
    fontSize: 14,
    fontWeight: 500,
    color: GRAY_COLORS[900],
    wordBreak: 'break-word'
  },
  checkIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${SUCCESS_COLORS[300]}`,
    backgroundColor: SUCCESS_COLORS[50],
    borderRadius: '50%',
    width: 22,
    height: 22
  },
  minusIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${ERROR_COLORS[300]}`,
    backgroundColor: ERROR_COLORS[50],
    borderRadius: '50%',
    width: 22,
    height: 22
  }
}))
